<div class="ny-event-progress-bar">
  <span
    class="ny-event-progress-bar--progress-line"
    [@progressBar]="{ value: progress, params: { newProgress: progress } }"
    [class]="eventName"
  ></span>

</div>
